import { makeStyles ,Box, Divider, IconButton, Toolbar, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import theme from 'theme';

const useStyles = makeStyles(() => ({
  title: {
    textTransform: 'capitalize',
  },
  spacedItems: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1), // similar to gap: 8px
    },
  },
}));

interface DrawerToolbarWithActionsProps {
  title: string;
  onClose?: (e: any) => void;
  actions?: React.ReactNode;
  middleActions?: React.ReactNode;
}

const DrawerToolbarWithActions: React.FC<DrawerToolbarWithActionsProps> = ({
  title,
  onClose,
  actions,
  middleActions,
}) => {
  const classes = useStyles();

  return (
    <>
      <Toolbar variant="dense" disableGutters>
        <Box display="flex" alignItems="center" width="100%">
          {/* Left: Title */}
          <Box flex={1} ml={2}>
            <Typography className={classes.title} variant="h4">
              {title}
            </Typography>
          </Box>

          {/* Center: Middle Actions */}
          {middleActions && (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
              {middleActions}
            </Box>
          )}

          {/* Right: Actions + Close */}
          <Box flex={1} className={classes.spacedItems}>
            {actions}
            {onClose && (
              <IconButton id="closeBtn" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      </Toolbar>
      <Divider />
    </>
  );
};

export default DrawerToolbarWithActions;
